module.exports = __webpack_public_path__ + "sh.svg?23f8c52d52e7960d1d4d2def69ec3543";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/sh.svg
// module id = 932
// module chunks = 27